import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { User } from 'lucide-react';
import type { Facets } from '../api/libraryApi';
import { ActiveFilterChips } from './ActiveFilterChips';
import { AssetPills } from './AssetPills';
import { FilterMenu } from './FilterMenu';

type Props = {
  facets: Facets | undefined;
  assetClass: string;
  analysts: string[];
  currency: string;
  onAssetClass: (assetClass: string) => void;
  onAnalysts: (analysts: string[]) => void;
  onCurrency: (currency: string) => void;
};

/** Asset class pills, then analyst and instrument menus, then whatever is picked as removable chips. */
export function LibraryFilterRow({ facets, assetClass, analysts, currency, onAssetClass, onAnalysts, onCurrency }: Props) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
      <AssetPills value={assetClass} onChange={onAssetClass} />
      <Box aria-hidden sx={{ width: '1px', height: 20, bgcolor: 'divider', mx: 0.5, display: { xs: 'none', sm: 'block' } }} />
      <FilterMenu label="Analyst" icon={User} options={facets?.analysts ?? []} selected={analysts} onChange={onAnalysts} multiple people />
      <FilterMenu label="Instrument" options={facets?.currencies ?? []} selected={currency ? [currency] : []} onChange={(v) => { onCurrency(v[0] ?? ''); }} />
      <ActiveFilterChips
        analysts={analysts}
        currency={currency}
        onRemoveAnalyst={(name) => { onAnalysts(analysts.filter((a) => a !== name)); }}
        onRemoveCurrency={() => { onCurrency(''); }}
      />
    </Stack>
  );
}
